import { arrToObj } from "fp-helpers-nba";
import teamsArr from "./../data/Teams.json";

export const teams = teamsArr;
export const teamsByID = arrToObj(teamsArr, "teamId", true);
export const teamsByConference = arrToObj(teamsArr, "confName", false);
export const teamsByDivision = arrToObj(teamsArr, "divName", false);
